import styled, { css } from "styled-components";
import { Color } from 'styles';

const moreStyle = css`
  background-color: #E2E2E2;
  border-top: 6px solid #292931;
`;
export const StyledUseWrapper = styled.section`
  background-color: ${Color.White};
  padding: 50px 0;
  width: 100%;
  
  ${({ more }) => more && moreStyle}
`;

export const StyledTextWrapper = styled.div`
  line-height: 34px;
   padding: 30px 0 60px;
`;


// WEBPACK FOOTER //
// ./src/routes/programDetails/programDetails.style.js